import Vue from 'vue';
import Router from 'vue-router';
import home from './home';
import zmlApp from './zmlApp';
import News from './News';
import video from './video';
import about from './about';
import user from './user.js';

Vue.use(Router);
const originalPush = Router.prototype.push;
// Router.prototype.push = function push (location) {
//   return originalPush.call(this, location).catch(err => err);
// };
export function createRouter () {
  return new Router({
    mode: 'history', // 注意这里也是为history模式
    scrollBehavior (to, from, saveTop) {
      if (saveTop) {
        return saveTop;
      } else {
        return {x: 0, y: 0, };
      }
    },
    routes: [].concat(
      user,home, zmlApp, News, video, about),
  });
}



// WEBPACK FOOTER //
// src/router/index.js